window.addEventListener('scroll', function () {
  const header = document.querySelector('.header-wrapper, header.header');
  if (window.scrollY > 50) {
    header.style.padding = '8px 0';
    header.style.transition = 'all 0.4s ease';
    header.style.boxShadow = '0 2px 20px rgba(0,0,0,0.5)';
  } else {
    header.style.padding = '20px 0';
    header.style.boxShadow = 'none';
  }
});